export const CHANGE_CHATGPT_SETTINGS = "CHANGE_CHATGPT_SETTINGS"
export const CHANGE_WIDGETS_SETTINGS = "CHANGE_WIDGETS_SETTINGS"
